import title from "../../images/integration/WebSCADA.png";
import Parameters from "shared/components/Parameters";
import Layout from "../../components/Layout";
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";


export function Page({ openPopup }) {
  // const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11, image12, image13, image14, image15, image16, image17, image18];
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <div className="d-flex justify-content-between flex-wrap">
            <h1 className="mb-4 ">
              Web-SCADA (SCADA NPT Compact)
            </h1>
            <MinDigitsBrand id="309051" />
          </div>

          <Parameters
            title=""
            image={title}
            // images={images}
            openPopup={openPopup}
            zoomColor="white"
          >
            <p>
              <b>Web-SCADA</b> представляет собой усовершенствованную версию традиционной SCADA, которая на стороне клиента использует веб-технологии. Web-клиент позволяет операторам выполнять различные операции с помощью браузера и не требует установки дополнительного программного обеспечения.
            </p>

            <p>Преимущества Web-SCADA по сравнению с обычной SCADA:</p>
            <ul className="mb-4 description__list">

              <li className="mb-1 description__number-li"><b>Удаленный доступ через веб-интерфейс</b>
                <ul>
                  <li><b>Web-SCADA</b> позволяет операторам и инженерам получать доступ к данным и управлять подстанцией через веб-браузер с любого устройства (ПК, планшет, смартфон) с доступом в интернет.
                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Кроссплатформенность</b>
                <ul>
                  <li> <b>Web-SCADA</b> работает на любых операционных системах (Windows, macOS, Linux, iOS, Android), поскольку использует веб-браузеры.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Мобильность и доступность</b>
                <ul>
                  <li> <b>Web-SCADA</b>позволяет операторам получать доступ к системе в реальном времени со смартфона или планшета, что особенно полезно для удаленных подстанций.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Масштабируемость</b>
                <ul>
                  <li> <b>Web-SCADA</b>легко масштабируется для поддержки большего числа пользователей и устройств благодаря облачным технологиям и веб-архитектуре.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Упрощенное обновление и обслуживание</b>
                <ul>
                  <li> Обновления и изменения <b>Web-SCADA</b> могут быть выполнены централизованно на сервере, что упрощает поддержку и снижает затраты.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Расширенные возможности визуализации</b>
                <ul>
                  <li> <b>Web-SCADA</b>использует современные веб-технологии (HTML5, JavaScript) для создания интерактивных и адаптивных интерфейсов.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Безопасность</b>
                <ul>
                  <li> <b>Web-SCADA</b>использует современные протоколы шифрования (HTTPS, SSL/TLS) для защиты данных, передаваемых через интернет.

                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Аналитика и отчетность</b>
                <ul>
                  <li> <b>Web-SCADA</b>включает встроенные инструменты для анализа данных и генерации отчетов, которые могут быть доступны через веб-интерфейс.

                  </li>
                </ul>
              </li>
            </ul>
            <p>
              Функционал Web-SCADA:
            </p>
            <ul className="mb-4 description__list">
              <li className="mb-1 description__number-li">
                Сбор данных с микропроцессорных устройств нижнего уровня по протоколам
                <ul>
                  <li>МЭК 61850-8-1 (MMS);</li>
                  <li>МЭК 60870-5-104/103;</li>
                  <li>Modbus TCP/RTU;</li>
                  <li>SNMP.</li>
                </ul>
              </li>
              <li className="mb-1 description__number-li">Логическая обработка данных</li>
              <li className="mb-1 description__number-li">Отображение данных с помощью различных гибко настраиваемых форм (мнемосхем, трендов, таблиц, аналитических графиков и т.п.)</li>
              <li className="mb-1 description__number-li">Управление оборудованием и мониторинг его состояния</li>
              <li className="mb-1 description__number-li">Архивирование данных с использованием СУБД SQLite, PostgreSQL</li>
              <li className="mb-1 description__number-li">Регистрация пользователей в системе с возможностью назначения ролей и выбором перечня полномочий</li>
              <li className="mb-1 description__number-li">Отображение мнемосхем с возможностью создавать пользовательские мнемосхемы</li>
              <li className="mb-1 description__number-li">Сбор, выгрузка и просмотр аварийных осциллограмм с помощью встроенного просмотровщика</li>
              <li className="mb-1 description__number-li">Гибко настраиваемая аварийная сигнализация</li>
            </ul>
            <a className="text-links" href="https://epsa-spb.ru/kontakty-2/">Запросить референс лист</a>
          </Parameters>
        </div>
      </div>
    </Layout>

  );
}

